module.exports = __webpack_public_path__ + "img/hl1.bd93eb51.png";